export default "__VITE_ASSET__D38GG2l4__"